<div class="reset-password-section">
  <div class="reset-password-container">
    <div class="reset-password-upper-section">
      <div class="reset-password-title-container">
        @if (currentForm === 1||currentForm === 2) {
        <span class="reset-password-title-text">{{resetSessionId?'Please check your phone':'Reset Password'}}</span>
        }
        @if (currentForm === 3) {
        <span class="reset-password-title-text">Please set a new password</span>
        }
        <div [routerLink]="'/login'" class="cross-icon-container"></div>
      </div>

      @if (currentForm === 1) {
      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="reset-password-field-secton">

          <!-- <div class="input-field-container">
            <span class="input-level-text">Registered phone number*</span>
            <div class="phone-number-container">
              <div class="country-code">+91</div>
              <input
                type="tel"
                class="input-field"
                placeholder="00000 00000"
                formControlName="phoneNumber"
                (keyup)="onInputBlur('phoneNumber')"
                (blur)="onInputBlur('phoneNumber')"
              />
            </div>
            @if (phoneNumberInvalid) {
            <span class="validation-message">Phone number is required</span>
            }
          </div> -->
          <div class="input-field-container">
            <span class="input-level-text">Registered email address*</span>
            <input type="text" class="input-field" placeholder="Enter your email address" formControlName="email"
              (keyup)="onInputBlur('email')" (blur)="onInputBlur('email')" />
            @if (emailInvalid) {
            <span class="validation-message">Email is required</span>
            }
          </div>
          <button class="reset-password-button dp-primary-btn">
            Reset password
          </button>
        </div>
      </form>

      }

      @if (currentForm === 2) {
      @if(resetSessionId){
      <div class="authentication-text" style="margin-top:12px">We’ve sent a one-time authentication code to your
        phone ending in
        {{mobNumber}}.</div>
      <div class="input-field-container" style="gap:24px">
        <div style="margin-top:40px">
          <span class="input-level-text">Authentication Code*</span>
          <input type="number" class="dp-input-control input-field" placeholder="Enter 6 digit OTP"
            [formControl]="forceResetOtp" (keyup)="onInputBlur('forceResetOtp')" (blur)="onInputBlur('forceResetOtp')"
            maxlength="6" (keydown)="restrictContactInput($event)" />


        </div>
        @if (phoneOtpInvalid) {
        <span class="phn-validation-message">OTP is required</span>
        }
        <button class="verify-button dp-primary-btn" (click)="forgotPasswordVerifyCode()">Verify code</button>
        @if (!isSpanDisabledForMobile) {
        <span class="resend-text" (click)="onResendForMobile()">
          Resend
        </span>
        } @if (isSpanDisabledForMobile) {
        <span class="resend-countdown-text" style="margin:0">
          Resend in {{ countdownForMobile }}
        </span>
        }
      </div>
      }@else{
      <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()">
        <div class="reset-password-field-secton">
          @if(!resetSessionId){
          <div class="input-field-container">
            <span class="input-level-text">Email OTP *</span>

            <input type="number" placeholder class="input-field" placeholder="Enter OTP sent on your email"
              formControlName="emailOtp" (keyup)="onInputBlur('emailOtp')" (blur)="onInputBlur('emailOtp')" />
            @if (emailOtpInvalid) {
            <span class="validation-message">OTP is required</span>
            }
          </div>
          }
          <button class="verify-button dp-primary-btn">Verify identity</button>
          @if (!isSpanDisabledForMobile) {
          <span class="resend-text" (click)="onResendForMobile()">
            Resend
          </span>
          } @if (isSpanDisabledForMobile) {
          <span class="resend-countdown-text">
            Resend in {{ countdownForMobile }}
          </span>
          }
        </div>
      </form>
      }
      }
      @if (currentForm === 3) {
      <form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
        <div class="reset-password-field-secton">
          <div class="input-field-container" style="position:relative">
            <span class="input-level-text">New password*</span>
            <input [type]="passwordVisible ? 'text' : 'password'" class="input-field " placeholder="Enter password"
              (keyup)="onInputBlur('password')" (blur)="onInputBlur('password')" formControlName="password"
              (copy)="$event.preventDefault()" (paste)="$event.preventDefault()" (cut)="$event.preventDefault()"
              (keydown)="restrictConfirmPasswordInput($event)" />
            @if (newPasswordForm.get('password')?.value) {
            <div class="password-icon" [style.background-image]="passwordVisible
                    ? 'var(' + visibilityOnIcon + ')'
                    : 'var(' + visibilityOffIcon + ')'
                " (click)="togglePasswordVisibility()"></div>
            }
            @if (passwordInvalid) {
            <span class="error-message"> Password complexity not matching</span>
            }

          </div>
          <div class="password-rules-div">

            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image':  !pwdvalidation.lengthCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Length: 8–15 characters</span>
            </div>

            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.nameCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain your First Name or Last Name or Satsang</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.emailCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain your Email Id</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.consecutiveValueCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <span class="password-span">Must not contain three consecutive letters or numbers (e.g., ABC, 123)</span>
            </div>
            <div class="password-rule">
              <div class="rule-notmatched-img" [ngStyle]="{
                  'background-image': !pwdvalidation.characterCheck
                    ? 'var(--radio-checkbox-inactive )'
                    : 'var(--radio-checkbox-active)'
                }"></div>
              <div>
                <span class="password-span">Must contain at least:</span>
                <ul style="margin:0">
                  <li class="password-span">One uppercase letter (A-Z)
                  </li>
                  <li class="password-span">One lowercase letter (a-z)</li>
                  <li class="password-span">One number (0-9)</li>
                  <li class="password-span">
                    One special character from the set: <span [innerHTML]="specialChars"></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="input-field-container" style="position:relative">
            <span class="input-level-text">Re-enter password*</span>

            <input [type]="reEnterPasswordVisible ? 'text' : 'password'" class="input-field "
              placeholder="Enter your password" formControlName="reEnterPassword" (copy)="$event.preventDefault()"
              (paste)="$event.preventDefault()" (cut)="$event.preventDefault()" (keyup)="onInputBlur('reEnterPassword')"
              (blur)="onInputBlur('reEnterPassword')" (keydown)="restrictConfirmPasswordInput($event)" />
            @if (newPasswordForm.get('reEnterPassword')?.value) {
            <div class="password-icon" [ngStyle]="{
                  'background-image': reEnterPasswordVisible
                    ? 'var(' + visibilityOnIcon + ')'
                    : 'var(' + visibilityOffIcon + ')'
                }" (click)="toggleReEnterPasswordVisibility()"></div>
            }
            @if (this.newPasswordForm.get('password')?.value!=this.newPasswordForm.get('reEnterPassword')?.value &&
            !passwordInvalid) {
            <span class="error-message"> Both passwords not matching </span>
            }
          </div>
          <button class="verify-button" [class]="(this.newPasswordForm.get('password')?.value==this.newPasswordForm.get('reEnterPassword')?.value &&
            !passwordInvalid)?'dp-primary-btn':'dp-primary-btn-disabled'">Confirm Password</button>


        </div>
      </form>
      }

    </div>
    <div class="footer-section">
      <a [routerLink]="'/login'" class="login-now-text">Back to Login</a>
    </div>
  </div>
</div>
<!-- <app-reset-popup [show]="showPopup" (close)="closePopup()"></app-reset-popup> -->